<template> 
    <font-awesome-icon :icon="obj.icon" :title="obj.title"></font-awesome-icon>
</template>
  
<script>
import { defineComponent } from 'vue';

import { LicenseStatus } from '@/common/constants';

export default defineComponent({
  props: {
      status: {
          type: String,
          default: 'Pending',
      },
      username: {
          type: String, 
          default: '',
      },
  },

  computed: {
      obj() {
          let temp = {};
          switch(this.status?.toLowerCase()) {
              case LicenseStatus.Active:
                  temp = {icon: ['fas', 'user-check'], title: 'Account.AccountActivationSuccess'};
                  break;
              case LicenseStatus.RegisterError:
                  temp = {icon: ['fas', 'user-xmark'], title: 'Account.AccountActivationRegisterError'};
                  break;
              case LicenseStatus.Suspended:
                  temp = {icon: ['fas', 'user-slash'], title: 'Account.AccountSuspended'};
                  break;
              case LicenseStatus.Grace:
                  temp = {icon: ['fas', 'user-clock'], title: 'Account.AccountActivationGracePeriod'};
                  break;
              case LicenseStatus.Inactive:
                 temp = {icon: ['fas', 'user-lock'], title: 'Account.AccountActivationInactive'};
                break;
              case LicenseStatus.Pending:
                temp = {icon: ['fas', 'clock-rotate-left'], title: 'Account.AccountActivationPending'};
                break;
              default:
                  temp = {icon: ['fas', 'ban'], title: 'Account.AccountActivationNA'};
          }
          return {icon: temp.icon, title: this.$t(temp.title, {param: this.username})};
      }
  },
});
</script>
